<template>
  <div class="rounded_10 p-4"
    :class="[{ disabledContent: !isLastIndex, 'shadow-sm bg-white  ': !isGradient, 'transparent-bgcolor-light': isGradient }]">
    <div class="calendar-container">
      <div class="header">
        <button @click="goToPreviousMonth" class="btn"
          :class="[{ 'shadow-sm bg-white  ': !isGradient, 'transparent-bgcolor-light text-white': isGradient }]">&lt;</button>
        <h4 class="m-0 text-white font-weight-bold">{{ monthNames[currentMonth] }} {{ currentYear }}</h4>
        <button class="btn" @click="goToNextMonth"
          :class="[{ 'shadow-sm bg-white  ': !isGradient, 'transparent-bgcolor-light text-white': isGradient }]">&gt;</button>
      </div>

      <div class="weekdays">
        <div v-for="day in weekDays" :key="day" class="day-name">{{ day }}</div>
      </div>

      <div class="days">
        <div v-for="blank in blankDays" :key="'b' + blank" class="day blank"></div>
        <div v-for="day in daysInMonth" :key="day" class="day"
          :class="[{ 'shadow-sm bg-white  ': !isGradient, 'transparent-bgcolor-light text-white': isGradient }]">
          {{ day }}
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { ref, computed } from 'vue'

const today = new Date()
const currentYear = ref(today.getFullYear())
const currentMonth = ref(today.getMonth()) // 0 = Jan

const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const daysInMonth = computed(() => {
  const days = new Date(currentYear.value, currentMonth.value + 1, 0).getDate()
  return Array.from({ length: days }, (_, i) => i + 1)
})

const blankDays = computed(() => {
  const firstDay = new Date(currentYear.value, currentMonth.value, 1).getDay()
  return Array.from({ length: firstDay })
})

const isGradient = computed(() => {
  return props.chatThemeSettings?.isGradient ?? false
})

const props = defineProps({
  isLastIndex: {
    type: Boolean,
    default: true
  },
  chatThemeSettings: {
    type: Object,
    default: () => ({})
  }
});



function goToPreviousMonth() {
  if (currentMonth.value === 0) {
    currentMonth.value = 11
    currentYear.value--
  } else {
    currentMonth.value--
  }
}

function goToNextMonth() {
  if (currentMonth.value === 11) {
    currentMonth.value = 0
    currentYear.value++
  } else {
    currentMonth.value++
  }
}
</script>

<style scoped>
.calendar-container {
  max-width: 400px;
  margin: auto;
  padding: 1rem;
  border-radius: 10px;
  text-align: center;
  font-family: sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.weekdays,
.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 10px;
  gap: 10px;
}

.day-name,
.day {
  padding: 10px;
  border: 0px solid #ddd;
}

.blank {
  background-color: transparent;
  border: none;
}
</style>
